import { ApplicationRef, Component, ComponentFactoryResolver, Injector, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { PopupComponent } from 'src/app/components/network-visibility/popup/popup.component';
import { GenericService } from 'src/app/services/generic.service';
declare const L: any;
import 'leaflet-draw';
import { LatLng } from 'leaflet';
import { get } from 'http';
import { forkJoin } from 'rxjs';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
// import 'leaflet-polylinedecorator';

@Component({
  selector: 'app-dealer-locate-device',
  templateUrl: './dealer-locate-device.component.html',
  styleUrls: ['./dealer-locate-device.component.css']
})
export class DealerLocateDeviceComponent implements OnInit {


  private map!: L.Map;
  private centroid: L.LatLngExpression = [17.4051564, 78.4927618];

  form: any | FormGroup
  marker2: any
  cid: any
  layerInfoLatLng: any = []
  objectInfoList: any = []
  assetStatusList: any = []
  objectInfoListFilter: any = []
  uomData: any = []
  objectTemplateList: any = []
  singleObjectTemplateData: any = []

  proofFile: any = ""
  proofFilePath: any = ""
  proofFileType: any = ""

  singleObjectInfoData: any = []
  layerslist: any = []
  singleLayerData: any = []
  defaultZoom: any = 14
  defaultCenter: any = [17.4065, 78.4772]
  latestLoc: any = []
  lat: any;
  lng: any
  multiLatLng: any = false
  area: any = []
  layerType: any = ""
  geojsonData:any = {
    "type": "FeatureCollection",
    "features": [
      {
        "type": "Feature",
        "properties": {
          "name": "Polygon 1"
        },
        "geometry": {}
      }
    ]
  }
  deleteId: any = ""

  objectTemplateId = ""
  objectInfoId: any
  originalCost: any = ""
  currentCost: any = ""
  branch: any = ""
  branchId: any = ""
  department: any = ""
  make: any = ""
  model: any = ""
  location: any = ""
  objectCondition: any = ""
  assetStatus: any = ""
  givenName: any = ""
  serialNumber: any = ""
  locationList: any = []
  dealerList: any = []
  dealerId: any = ""
  branchList: any = []
  maintenanceList: any = []
  objectColorCode: any = ""
  isObjectColorCode: any = false

  maintenanceType = [
    {
      key: "Preventive Maintenance (PM) Schedule",
      value: "PreventiveMaintenanceSchedule"
    },
    {
      key: "Corrective Maintenance Schedule",
      value: "CorrectiveMaintenanceSchedule"
    },
    {
      key: "Predictive Maintenance Schedule",
      value: "PredictiveMaintenanceSchedule"
    },
    {
      key: "Condition-Based Maintenance (CBM)",
      value: "ConditionBasedMaintenance"
    }
  ]

  frequencyType = [
    {
      key: "Daily: Operational checks (temperature, pressure, noise, etc.)",
      value: "Daily"
    },
    {
      key: "Weekly: Lubrication, filter checks, fluid levels",
      value: "Weekly"
    },
    {
      key: "Monthly: In-depth inspections, cleaning, software updates",
      value: "Monthly"
    },
    {
      key: "Quarterly: Component replacements (belts, seals), diagnostics",
      value: "Quarterly"
    },
    {
      key: "Annually: Major overhauls, part replacements, certifications",
      value: "Annually"
    }
  ]

  showFilter: any = false
  detailShow: any = false
  objectTypeData: any = [];
  objectGroupData: any = [];
  usersList: any = [];
  isLoading: any = false;
  maintenanceScheduleList: any = [];
  file: any;
  imagesList: any = [];
  imagesWithDetails: any = [];

  largeImage: any = "";
  iconFile: any;
  icon: any = '';
  todayDate: any;


  minEndDate: any;
  editPerformanceMatrix: any = false
  performanceMatrixList: any = [];
  nameValue: any;
  performanceMatrix: any;
  acquisitionDate: any = "";
  salvageValue: any;
  depreciationMethod: any;
  assetLifeNumber: any;
  asset_Category: any = "";
  objectCategoryList: any = [];
  assetDepreciationDataList: any = [];
  departmentInfoList: any = [];

  putToUseDate: any = "";
  isOriginalCost: any = false;
  isAsset_Category: any = false;
  isPutToUseDate: any = false;
  isSalvageValue: any = false;
  isAssetLifeNumber: any = false;

  assetConditions = [
    { value: 'Good', label: 'Good' },
    { value: 'UnderRepair', label: 'Under Repair' },
    { value: 'Scrap', label: 'Scrap' }
  ];

  tags: any = []
  isClone: any = false
  templateName: any;
  menuToggle: any = false


  repairInfoForm: any | FormGroup;
  addAsset: any | FormGroup;
  isMaintenanceSchedule: any = false
  assetMonitoring: any = false
  assetMonitoringFrequency: any = 0
  assetMonitoringTimeSpan: any = 0
  assetHealth: any = false
  connectionsList: any = []
  assetHealthList: any = []
  searchFilter: any = ""

  constructor(private fb: FormBuilder,private toastr: ToastrService,private generic_service: GenericService,
    private resolver: ComponentFactoryResolver,
    private appRef: ApplicationRef,private router: Router,
    private injector: Injector) {

      this.generic_service.menuToggle.subscribe((value) => {
        this.menuToggle = Boolean(value)
        if(this.menuToggle){
          this.bi_fullscreen = "fullscreen-map1"
        }else{
          this.bi_fullscreen = "fullscreen-map"
        }

      });
    }



  @Input() goodCount: number = 75;
  @Input() badCount: number = 25;

  goodPercentage: number = 0;
  badPercentage: number = 0;


  parentSelectedList:any = [];
  parentDropdownSettings: IDropdownSettings = {
    singleSelection: false,
    idField: 'objectInfoId',
    textField: 'givenName',
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    itemsShowLimit: 3,
    allowSearchFilter: true
  };


  ngOnInit(): void {
    const now = new Date();
    this.todayDate = now.toISOString().split('T')[0]; // Format: YYYY-MM-DD
    const total = this.goodCount + this.badCount;
    this.goodPercentage = total > 0 ? (this.goodCount / total) * 100 : 0;
    this.badPercentage = total > 0 ? (this.badCount / total) * 100 : 0;

    this.cid = sessionStorage.getItem('cid')
    this.getAllLocation()
    this.getAllIDealerWithoutPagination()
    this.initMap();

  }

  getAllIDealerWithoutPagination(){
    this.generic_service.getAllIDealerWithoutPagination().subscribe(
      (res:any)=> {
        console.log(res)
        this.dealerList = res.response
      },
      (err:any)=>{
        console.log(err)
      }
    )
  }

  dealerChange(){
    this.clearObject()

    for(let list of this.dealerList){
      if(list.idealerId == Number(this.dealerId)){
        console.log(list)
        if(list.locationObj != null && list.locationObj,length != 0){
          for(let location of list.locationObj){
            location.isChecked = false
          }
        }
        this.locationList = list.locationObj || []
      }
    }
  }


  getAllLocation(){
    this.generic_service.getAllLocation().subscribe(
      (res:any)=> {
        console.log(res)

        if(res.response != null && res.response.length != 0){
          for(let list of res.response){
            list.isChecked = false
          }
        }
   
        this.locationList = res.response
      },
      (err:any)=>{
        console.log(err)
      }
    )
  }

  clearObject() {
    this.locationCheckList = [];
    this.objectInfoList = [];
    this.singleObjectInfoData = []
    this.showFilter = false;
    this.detailShow = false;


    if (this.map) {
      this.map.eachLayer((layer: any) => {
        // Remove all layers except the tile layer (usually)
        if (!layer._url) { // tile layer has _url property
          this.map.removeLayer(layer);
        }
      });
    }

    for(let list of this.locationList){
      list.isChecked = false
    }
  }

locationCheckList: any = [];

locationCheck(event: any, list: any) {

    this.singleObjectInfoData = []
    this.showFilter = false;
    this.detailShow = false;
  console.log(list)
  console.log(event)
  if (!list.isChecked) {
    list.isChecked = true;
    this.locationCheckList.push(list);
  } else {
    // Find index of unchecked item
    const index = this.locationCheckList.findIndex(
      (loc: any) => loc.locationId === list.locationId
    );

    if (index !== -1) {
      this.locationCheckList.splice(index, 1);
    }

    // Set unchecked flag here
    list.isChecked = false;
    console.log(list);
    console.log(list.isChecked);

  }

  this.objectInfoList = [];

  if (this.locationCheckList.length === 0) {
    this.initMap(); // Reset or clear map if needed
    return; // early exit to avoid calling forkJoin on empty array
  }

  // Create array of observables
  const requests = this.locationCheckList.map((loc: any) =>
    this.generic_service.getAllByLocationAndCid(loc.zone)
  );

  forkJoin(requests).subscribe(
    (responses: any) => {
      // responses is an array of each call's response
      for (const res of responses) {
        if (res.response != null) {
          this.objectInfoList.push(...res.response);
        }
      }


      this.initMap();

      if (this.map && this.objectInfoList.length > 0) {
        const latLngs = this.objectInfoList
          .filter((item: { lat: any; lng: any }) => item.lat && item.lng)
          .map((item: { lat: any; lng: any }) => [item.lat, item.lng]);

        if (latLngs.length > 0) {
          const bounds = L.latLngBounds(latLngs);
          this.map.fitBounds(bounds, { 
            padding: [20, 20]
          });
          this.map.invalidateSize();
        }
      }
    },
    (err: any) => {
      console.log(err);
    }
  );
}

removeImage(index: any){
  this.imagesWithDetails.splice(index, 1)
}

  markerIcon = {
    icon: L.icon({
      iconSize: [25, 41],
      iconAnchor: [10, 41],
      popupAnchor: [2, -40],
      // specify the path here
      iconUrl: "https://unpkg.com/leaflet@1.5.1/dist/images/marker-icon.png",
      shadowUrl: "https://unpkg.com/leaflet@1.5.1/dist/images/marker-shadow.png"
    })
  };


clearMapLayers() {
  // Remove drawn items
  this.map.eachLayer((layer: any) => {
    // Skip tile layers
    if (layer instanceof L.TileLayer) return;

    // Remove everything else (markers, polylines, GeoJSON, etc.)
    this.map.removeLayer(layer);
  });

  // Clear stored area points and flags
  this.area = [];
  this.multiLatLng = false;
  this.isObjectColorCode = false;
  this.layerType = '';

  // Reset GeoJSON features
  this.geojsonData = {
    type: "FeatureCollection",
    features: []
  };

  // Reset marker2 if used
  if (this.marker2) {
    this.map.removeLayer(this.marker2);
    this.marker2 = undefined;
  }

  // Optionally reset lat/lng if needed
  this.lat = undefined;
  this.lng = undefined;

  // Optionally reset the default center if needed
  // this.defaultCenter = [initialLat, initialLng];
}


private initMap(): void {

  if (this.map) {
    this.map.remove();
  }
  const singleData = this.singleObjectInfoData?.[0];

  if (singleData) {
    if (!singleData.multiLatLng) {
      if (singleData.lat && singleData.lat !== 0) {
        this.defaultCenter = [singleData.lat, singleData.lng];
      } else if (singleData.area?.length) {
        const firstPoint = singleData.area[0];
        this.defaultCenter = [firstPoint.lat, firstPoint.lng];
      }
    }
  }else{

  if(this.latestLoc.length != 0){
    this.defaultCenter = this.latestLoc;
  }else{
   setTimeout(() => {
      if (this.map && this.objectInfoList.length > 0) {
        const latLngs = this.objectInfoList
          .filter((item: { lat: any; lng: any; }) => item.lat && item.lng)
          .map((item: { lat: any; lng: any; }) => [item.lat, item.lng]);

        if (latLngs.length > 0) {
          const bounds = L.latLngBounds(latLngs);
          this.map.fitBounds(bounds, { padding: [20, 20],
                maxZoom: 12
          }
          );
          this.map.invalidateSize();
        }
      }
    }, 1500);
  }
 
  }

  if(this.latestLoc.length != 0){
    this.defaultCenter = this.latestLoc;
  }
  

  // Initialize Map
  this.map = L.map('map', {
    center: this.defaultCenter,
    zoom: this.defaultZoom
  });

  const tiles = L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
    maxZoom: 22,
    minZoom: 2,
    attribution: '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>'
  }).addTo(this.map);

  // Drawing Control
  const drawnItems = L.featureGroup().addTo(this.map);
  const drawControl = new L.Control.Draw({
    edit: { featureGroup: drawnItems },
    draw: {
      marker: true,
      polygon: false,
      polyline: true,
      circle: false,
      rectangle: false,
      circlemarker: false
    }
  });
  this.map.addControl(drawControl);

  // Drawing Event Handler
  this.map.on(L.Draw.Event.CREATED, (event: any) => {
    const layer = event.layer;

    if (event.layerType === "polyline") {
      this.layerType = "Polyline";
      this.multiLatLng = true;
      this.isObjectColorCode = true;
      this.area = layer._latlngs.map((p: any) => ({ lat: p.lat, lng: p.lng }));
      drawnItems.addLayer(layer);
    } else if (event.layerType === "marker") {
      this.layerType = "Marker";
      this.lat = layer._latlng.lat;
      this.lng = layer._latlng.lng;
      this.multiLatLng = false;
      this.isObjectColorCode = false;
      this.objectColorCode = ""
      this.area = [];

      if (this.marker2) {
        this.map.removeLayer(this.marker2);
      }
    }

    document.getElementById("add-device-popup")?.click();
  });

  // --- Render Markers or Lines ---

  if (singleData) {
    if (!singleData.multiLatLng) {
      if (singleData.lat && singleData.lat !== 0) {
        const iconUrl = singleData.icon || 'assets/image (1).png';
        const customHtmlIcon = L.divIcon({
          className: '',
          html: `
            <div style="
              position: relative;
              width: 60px;
              height: 60px;
              background: white;
              border: 3px solid #e94141ff;
              border-radius: 50%;
              overflow: hidden;
              box-shadow: 0 2px 6px rgba(0,0,0,0.3);
            ">
              <img src="${iconUrl}" style="width: 100%; height: 100%; object-fit: cover;" />
              <div style="
                position: absolute;
                bottom: -10px;
                left: 50%;
                transform: translateX(-50%);
                width: 0;
                height: 0;
                border-left: 10px solid transparent;
                border-right: 10px solid transparent;
                border-top: 15px solid #2c3e50;
              "></div>
            </div>
          `,
          iconAnchor: [30, 30],
          popupAnchor: [0, 0]
        });

        L.marker([singleData.lat, singleData.lng], { icon: customHtmlIcon })
          .addTo(this.map)

      } else {
        this.toastr.error("No location available");
      }
    } else if (singleData.area?.length) {
      const latlngs = singleData.area.map((p: any) => [parseFloat(p.lng), parseFloat(p.lat)]);
      const feature = {
        type: "Feature",
        color: singleData.objectColorCode || 'black',
        properties: singleData,
        geometry: {
          type: "LineString",
          coordinates: latlngs
        }
      };

      this.geojsonData.features.push(feature);

      L.geoJSON(feature, {
        style: { color: feature.color, weight: 7 }
      }).addTo(this.map)
        .on('click', () => this.onMarkerClick(singleData));
    }
  } else {
    // Multiple objects
    for (const obj of this.objectInfoList) {
      const iconUrl = obj.icon || 'assets/image (1).png';
      const customHtmlIcon = L.divIcon({
        className: '',
        html: `
          <div style="
            position: relative;
            width: 60px;
            height: 60px;
            background: white;
            border: 3px solid #e94141ff;
            border-radius: 50%;
            overflow: hidden;
            box-shadow: 0 2px 6px rgba(0,0,0,0.3);
          ">
            <img src="${iconUrl}" style="width: 100%; height: 100%; object-fit: cover;" />
            <div style="
              position: absolute;
              bottom: -10px;
              left: 50%;
              transform: translateX(-50%);
              width: 0;
              height: 0;
              border-left: 10px solid transparent;
              border-right: 10px solid transparent;
              border-top: 15px solid #2c3e50;
            "></div>
          </div>
        `,
        iconAnchor: [30, 30],
        popupAnchor: [0, 0]
      });

      if (!obj.multiLatLng) {
        if (obj.lat && obj.lat !== 0) {
    
          L.marker([obj.lat, obj.lng], { icon: customHtmlIcon })
            .addTo(this.map)
            .on('click', () => this.onMarkerClick(obj))

                .on('mousemove', (e: any) => {
      const latlng = e.latlng;
      hoverMarker.setLatLng(latlng);

      if (!this.map.hasLayer(hoverMarker)) {
        hoverMarker.addTo(this.map);
      }
    })

    .on('mouseout', () => {
      if (this.map.hasLayer(hoverMarker)) {
        this.map.removeLayer(hoverMarker);
      }
    });

const hoverMarker = L.marker([0, 0], {
  icon: L.divIcon({
    className: 'hover-marker',
    html: `
      <div style="
        position: relative;
        width: 240px;
        background: #fdfdfd;
        border: 1px solid #d6e4f0;
        border-radius: 10px;
        padding: 14px 16px;
        font-family: 'Segoe UI', Tahoma, sans-serif;
        font-size: 14px;
        color: #2c3e50;
        box-shadow: 0 4px 12px rgba(0,0,0,0.1);
      ">
        <div style="display: flex; margin-bottom: 8px;">
          <span style="font-weight: 600; width: 90px; color:#34495e;">Asset Id</span>
          <span style="margin: 0 6px; font-weight: bold; color:#7f8c8d;">:</span>
          <span>${obj.objectInfoId || '--'}</span>
        </div>
        <div style="display: flex; margin-bottom: 8px;">
          <span style="font-weight: 600; width: 90px; color:#34495e;">Asset</span>
          <span style="margin: 0 6px; font-weight: bold; color:#7f8c8d;">:</span>
          <span>${obj.givenName || '--'}</span>
        </div>
        <div style="display: flex; margin-bottom: 8px;">
          <span style="font-weight: 600; width: 90px; color:#34495e;">Condition</span>
          <span style="margin: 0 6px; font-weight: bold; color:#7f8c8d;">:</span>
          <span>${obj.objectCondition || '--'}</span>
        </div>
        <div style="display: flex; margin-bottom: 8px;">
          <span style="font-weight: 600; width: 90px; color:#34495e;">Location</span>
          <span style="margin: 0 6px; font-weight: bold; color:#7f8c8d;">:</span>
          <span>${obj.location || '--'}</span>
        </div>
        <div style="display: flex;">
          <span style="font-weight: 600; width: 90px; color:#34495e;">Branch</span>
          <span style="margin: 0 6px; font-weight: bold; color:#7f8c8d;">:</span>
          <span>${obj.branch || '--'}</span>
        </div>
        
        <!-- caret (arrow) -->
        <div style="
          position: absolute;
          bottom: -12px;
          left: 50%;
          transform: translateX(-50%);
          width: 0;
          height: 0;
          border-left: 12px solid transparent;
          border-right: 12px solid transparent;
          border-top: 12px solid #fdfdfd;
          filter: drop-shadow(0 -1px 1px rgba(0,0,0,0.15));
        "></div>
      </div>
    `,
    iconAnchor: [120, 210],
  }),
  interactive: false
});

        }
      } else if (obj.area?.length) {
        const latlngs = obj.area.map((p: any) => [parseFloat(p.lng), parseFloat(p.lat)]);
        const feature = {
          type: "Feature",
          color: obj.objectColorCode || 'black',
          properties: obj,
          geometry: {
            type: "LineString",
            coordinates: latlngs
          }
        };

        this.geojsonData.features.push(feature);

        L.geoJSON(feature, {
          style: { color: feature.color, weight: 7 }
        }).addTo(this.map)
          .on('click', () => this.onMarkerClick(obj));
      }
    }



    
  }

  // Final GeoJSON Render (in case any features were added manually)
  if(this.geojsonData.features && this.geojsonData.features.length != 0){

    this.geojsonData.features.forEach((feature: any) => {
      L.geoJSON(feature, {
        style: { color: feature.color || 'black', weight: 7 }
      }).addTo(this.map)
        .on('click', () => this.onMarkerClick(feature.properties));
    });
  }

}

  defaultIcon = L.icon({
    iconUrl: 'assets/image (1).png', // your path may vary ...
    iconSize: [80, 80],
    iconAnchor: [30, 2],
    popupAnchor: [0, -2]
  });

  ngOnDestroy(){
    this.map.remove();
  }

  onMarkerClick(objectInfo: any) {
    this.isFullscreen = false;
    this.viewObject(objectInfo.objectInfoId)
  }

  closeDetailView(){
    // this.map.remove();
    this.showFilter = false
    this.detailShow = false

    this.singleObjectInfoData = []
    // setTimeout(() => {
    //   if (this.map) {
    //     this.map.invalidateSize();
    //     this.map.setView(this.defaultCenter, this.map.getZoom());
    //   }
    // }, 500);


  if(this.latestLoc.length != 0){
    this.defaultCenter = this.latestLoc;

    setTimeout(() => {
      if (this.map && this.latestLoc.length > 0) {
        const latLngs = this.latestLoc

        if (latLngs.length > 0) {
          const bounds = L.latLngBounds(latLngs);
          this.map.fitBounds(bounds);
              this.map.setView(this.latestLoc, 16);
          this.map.invalidateSize();
        }
      }
    }, 500);

    
  }else{
    setTimeout(() => {
      if (this.map && this.objectInfoList.length > 0) {
        const latLngs = this.objectInfoList
          .filter((item: { lat: any; lng: any; }) => item.lat && item.lng)
          .map((item: { lat: any; lng: any; }) => [item.lat, item.lng]);

        if (latLngs.length > 0) {
          const bounds = L.latLngBounds(latLngs);
          this.map.fitBounds(bounds, { padding: [20, 20] });
          this.map.invalidateSize();
        }
      }
    }, 500);
  }



    this.initMap()


  }




viewObject(objectInfoId: any) {
  this.showFilter = false;
  this.detailShow = true;
  this.objectInfoId = objectInfoId;

  this.generic_service.getObjectInfoById(objectInfoId).subscribe(
    (response: any) => {
      this.singleObjectInfoData = [];
      this.singleObjectInfoData.push(response.response);
      this.imagesList = response.response.images;
      this.imagesWithDetails = response.response.imagesWithDetails;
      this.latestLoc = []
      if (response.response.lat && response.response.lat !== 0) {

        // Wait until Angular renders the map container
        setTimeout(() => {
          if (this.map) {
            this.map.invalidateSize(); // Fixes blank map
            this.map.setView(
              [response.response.lat, response.response.lng], 16);
              this.latestLoc = [response.response.lat, response.response.lng]
            // Add marker explicitly (if not already added)
            // L.marker([response.response.lat, response.response.lng]).addTo(this.map);
          }
        }, 1000); // small delay ensures container is visible
      }
    },
    (error: any) => {
      console.log(error);
    }
  );
}


  getObjectInfoById(objectInfoId: any){
    this.showFilter = false
    this.detailShow = true
    this.objectInfoId = objectInfoId
    this.generic_service.getObjectInfoById(objectInfoId).subscribe(
      (response:any)=>{
        this.map.remove();

        this.singleObjectInfoData = []
        this.singleObjectInfoData.push(response.response)
        this.imagesList = response.response.images
        this.imagesWithDetails = response.response.imagesWithDetails
        // this.geojsonData.features[0].geometry.coordinates = latlang[0]
        // this.geojsonData.features[0].geometry.type = "Point"

        // console.log(this.geojsonData)

        this.initMap()


      },
      (error:any)=>{
        console.log(error)
      }
    )
  }

  removeMaintenance(index: any){
    this.maintenanceList.splice(index, 1)
  }

  addMaintenanceSchedule(body: any){
    console.log(body)
    this.generic_service.addMaintenanceSchedule(body).subscribe(
      (response: any)=>{
        console.log(response)
      },
      (error: any)=>{
        this.toastr.error(error.error.errors[0].description);
        console.log(error)
      }
    )
  }


  toggleFilter(){
    this.detailShow = false
    this.showFilter = !this.showFilter
  }

  refreshTickets(){
    this.singleObjectInfoData = []
    this.showFilter = false
    this.detailShow = false
    this.searchFilter = ""
    this.dealerId = ""
    this.resetFilter()
    this.clearObject()
    this.getAllLocation()

  }

resetFilter(){

  this.objectInfoList = []
  this.objectInfoListFilter = []
}








  getAllByLocationAndCid(location: any){
    this.generic_service.getAllByLocationAndCid(location).subscribe(
      (res: any) => {
        console.log('Location Result:', res);
        if(res.response == null || res.response.length == 0 || res.response == undefined){
          this.objectInfoList = []
          return

        }
        this.objectInfoList = res.response
        this.initMap();



        setTimeout(() => {
          if (this.map && this.objectInfoList.length > 0) {
            const latLngs = this.objectInfoList
              .filter((item: { lat: any; lng: any; }) => item.lat && item.lng)
              .map((item: { lat: any; lng: any; }) => [item.lat, item.lng]);

            if (latLngs.length > 0) {
              const bounds = L.latLngBounds(latLngs);
              this.map.fitBounds(bounds, { padding: [20, 20] }); // optional padding
              this.map.invalidateSize();
            }
          }
        }, 500);

      },
      (err: any) => {
        console.log('Serial Number Error:', err);
      }
    );
  }








  

  getMaintenanceType(type: any){
    for(let list of this.maintenanceType){
      if(list.value == type){
        return list.key
      }
    }
    return ""
  }


  addTicketImageBtn(){
    document.getElementById("add-TicketImage-btn")?.click()
  }

  onTicketChange(event: any) {
    this.file = event.target.files[0];
    this.onTicketUpload()
  }

  onTicketUpload() {
    console.log(this.file);
    this.generic_service.uploadImage(this.file).subscribe((event: any) => {
      console.log(event);
      this.imagesList.push(event.response)
      let obj = {
        "image": event.response,
        "name": this.file.name,
        "type": this.file.type
      }
      this.imagesWithDetails.push(obj)
    });
  }

  selectLargeImage(largeImage: any){
    this.largeImage = largeImage
  }

  onUploadIcon() {
    this.generic_service.uploadImage(this.iconFile).subscribe((event: any) => {
      console.log(event);
      this.icon = event.response
    });
  }


  removeFile(fileInput: HTMLInputElement) {
    fileInput.value = '';
    this.file = ''
  }

  getObjectInfoByWildSearch(){
    console.log(this.searchFilter)
    if(this.searchFilter == "" || this.searchFilter == null){
      return
    }
    this.generic_service.getObjectInfoByWildSearch(this.searchFilter).subscribe(
      (res: any) => {
        if(res.response == null || res.response.length == 0 || res.response == undefined){
          this.objectInfoList = []
          return

        }
        this.objectInfoList = res.response
      },
      (err: any) => {
        console.log('Serial Number Error:', err);
      }
    );
  }


  isFullscreen = false;
  bi_fullscreen: any = "fullscreen-map"
// bi-fullscreen-exit
  toggleFullscreen(): void {
    this.isFullscreen = !this.isFullscreen;

    // Optional: if using a map library like Leaflet or Google Maps,
    // call map.invalidateSize() or equivalent here
    setTimeout(() => {
      this.refreshMapSize();
    }, 300);
  }

  refreshMapSize() {
    setTimeout(() => {
      if (this.map) {
        this.map.invalidateSize();
        this.map.setView(this.map.getCenter(), this.map.getZoom());
      }
    }, 1000); // match this with your CSS transition timing
  }


}
